/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {graphql} from "babel-plugin-relay/macro";
import {createFragmentContainer} from "react-relay";
import PieceSettingsReprocessItem from "ui/feature/piece-settings/PieceSettingsReprocessItem";
import {
    PieceSettingsBodyEmployeeOnlySection_piece$data
} from "ui/feature/piece-settings/__generated__/PieceSettingsBodyEmployeeOnlySection_piece.graphql";
import styles from "./PieceSettingsBodyEmployeeOnlySection.module.scss";
import Button from "ui/kit/buttons/Button";
import PieceCreateEndToEndTest from "mutation/PieceCreateEndToEndTest";
import Header1 from "ui/kit/typography/Header1";

interface Props {
    piece: PieceSettingsBodyEmployeeOnlySection_piece$data;
}

const PieceSettingsBodyEmployeeOnlySection: React.FC<Props> = ({piece}) => {

    const createEndToEndTest = React.useCallback(async () => {
        await PieceCreateEndToEndTest(piece.id);
        alert("End to End Test Created");
    }, [piece.id]);

    return (
        <div className={styles.section}>
            <Header1>Employee Options</Header1>
            <PieceSettingsReprocessItem pieceId={piece.id}/>
            <Button title={"Create End to End Test"} onClick={createEndToEndTest}/>
            {piece.end_to_end_test_file_download_url ?
                <a href={piece.end_to_end_test_file_download_url} target="_blank" rel="noreferrer">Download End to End
                    Test</a> : <p>No end to end test to download</p>}
        </div>
    );
}

export default createFragmentContainer(PieceSettingsBodyEmployeeOnlySection, {
    piece: graphql`
    fragment PieceSettingsBodyEmployeeOnlySection_piece on MusicPiece {
        id
        end_to_end_test_file_download_url
    }
    `
});